export default __webpack_public_path__ + "static/media/representational.da8506fc.png";